import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ref-doctor-modal',
  templateUrl: './ref-doctor-modal.component.html',
  styleUrls: ['./ref-doctor-modal.component.scss'],
})
export class RefDoctorModalComponent implements OnInit {
  isLoading = true;
  Errors = null;
  titles = null;
  mode = null;
  countries: any = [];
  data = null;
  Success = null;
  cities: any = [];
  banks: any = [];
  specializations: any = [];
  filterddata: any = [];
  role = localStorage.getItem('role');
  canDiscount = [];
  userId = localStorage.getItem('id');
  private _searchText: string;
  users: any;

  get searchText(): string {
    return this._searchText;
  }

  set searchText(value: string) {
    this._searchText = value;
    this.filterddata = this.filterdata(value);
  }

  filterdata(searchString: string) {
    return this.titles.filter(
      (log) =>
        log.Acount_Name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1
    );
  }

  stateForm = new FormGroup({
    ref_doctor_code: new FormControl(0, Validators.required),
    ref_doctor_name: new FormControl('', Validators.required),
    Acount_Name: new FormControl(''),
    Account_No: new FormControl(''),
    Bank_Name: new FormControl(''),
    Share_per: new FormControl(0),
    Hospital_Name: new FormControl(''),
    mobile: new FormControl('', Validators.required),
    Revenue_Shared: new FormControl(''),
    Status: new FormControl(''),
    Refer_Type_Code: new FormControl(''),
    Country: new FormControl(''),
    Designation: new FormControl(''),
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    area: new FormControl(0),
    specialisation_code: new FormControl(''),
    email: new FormControl(''),
    U_Name: new FormControl(''),
    Password: new FormControl(''),
    branch_code: new FormControl(''),
    fin_year: new FormControl(''),
  });

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService
  ) {}

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      ref_doctor_code,
      ref_doctor_name,
      Acount_Name,
      Account_No,
      Bank_Name,
      Share_per,
      Hospital_Name,
      mobile,
      Revenue_Shared,
      Status,
      Refer_Type_Code,
      Country,
      Designation,
      address1,
      address2,
      city,
      area,
      specialisation_code,
      email,
      U_Name,
      Password,
      branch_code,
      fin_year,
    } = this.stateForm.value;
    this.auth
      .postRefDr(
        ref_doctor_code,
        Acount_Name,
        Acount_Name,
        Account_No,
        Bank_Name,
        Share_per,
        Hospital_Name,
        mobile,
        Revenue_Shared,
        Status,
        Refer_Type_Code,
        Country,
        Designation,
        address1,
        address2,
        city,
        area,
        specialisation_code,
        email,
        Acount_Name,
        Password,
        branch_code,
        fin_year
      )
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess;
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal();
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.Errors = this.data.message;
            this._snackBar.open(this.data.message, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            console.log(resSuccess);
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }

  closeModal() {
    this.modal.closeModal();
  }

  ngOnInit(): void {
    this.auth.getcountry().subscribe(
      (resSuccess) => {
        this.countries = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
    this.auth.getCity().subscribe(
      (resSuccess) => {
        this.cities = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
    this.auth.getBanks().subscribe(
      (resSuccess) => {
        this.banks = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
    this.auth.getSpecials().subscribe(
      (resSuccess) => {
        this.specializations = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
    this.auth.getRefDr().subscribe(
      (resSuccess: any) => {
        this.titles = resSuccess.reverse();
        this.filterddata = this.titles;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.auth.getUser().subscribe(
      (resSuccess: any) => {
        this.users = resSuccess.filter((t) => t.CanAuthDiscount == true);
        this.canDiscount = this.users.filter(
          (t) => t.Employee_id === +this.userId
        );
        console.log(this.canDiscount, 'Dissssssssssssssss');
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  addNew() {
    this.mode = 'add';
  }
  edit(title) {
    this.mode = 'edit';
    this.stateForm.patchValue({
      ref_doctor_code: title.ref_doctor_code,
      ref_doctor_name: title.ref_doctor_name,
      Acount_Name: title.Acount_Name,
      Account_No: title.Account_No,
      Bank_Name: title.Bank_Name,
      Share_per: title.Share_per,
      Hospital_Name: title.Hospital_Name,
      mobile: title.mobile,
      Revenue_Shared: title.Revenue_Shared,
      Status: title.Status,
      Refer_Type_Code: title.Refer_Type_Code,
      Country: title.Country,
      Designation: title.Designation,
      address1: title.address1,
      address2: title.address2,
      city: title.city,
      area: title.area,
      specialisation_code: title.specialisation_code,
      email: title.email,
      U_Name: title.U_Name,
      Password: title.Password,
      branch_code: title.branch_code,
      fin_year: title.fin_year,
    });
    console.log(this.stateForm.value);
  }

  delete(title) {
    this.auth
      .delSet('/api/refdoctor/deleteRefDoctor', title.ref_doctor_code)
      .subscribe(
        (resSuccess) => {
          this.filterddata = this.filterddata.filter(
            (dattum) => dattum.ref_doctor_code !== title.ref_doctor_code
          );
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }
}
